var _defs, _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b06d25;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: #5b3822;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 119.5,
    y1: 336.2,
    x2: 228.2,
    y2: 258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55849c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a9ab2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 175,
    y1: 171.2,
    x2: 175,
    y2: 218.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eab286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faca9b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 175,
    y1: 77.7,
    x2: 175,
    y2: 114.9,
    xlinkHref: "#linear-gradient-2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.1,318.4c0,6.4-.5,12.8-1.4,18.9H53.3c-.9-6.2-1.4-12.5-1.4-18.9,0-67.9,57.8-122.9,123-122.9,65.3,0,123.1,55,123.1,122.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.9,212.4l40.1-87.8,40.1,87.8s-14,29.1-40.1,29.1c-26.2,0-40.1-29.1-40.1-29.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M250,87.8c0,.9,0,1.8-.1,2.7-.3,9.5-2.3,19.7-5.6,29.8-11.2,34.4-38.1,68.1-69.2,68.1-36.2,0-66.5-45.1-73.5-84h0c0-.2,0-.4-.1-.7-.8-4.5-1.3-8.9-1.4-13.2-.1-.9-.1-1.8-.1-2.7s0-1.8.1-2.5c0-.6,0-1.3.1-1.8-.1-1,0-2,.1-2.9.8-7.5,2.6-14.7,5.4-21.5,11.1-27.2,37.9-46.4,69.4-46.4,35.5,0,65.1,24.6,72.9,57.9.5,2,.9,4.1,1.1,6.3h0c.4,2.2.6,4.3.6,6.6.1.5.1,1.1.1,1.8.1.8.1,1.7.1,2.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M101.6,104.3c0-.2,0-.4-.1-.6,0,.2.1.4.1.6Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.1,76.8h0c-8.2,2.8-15.8,4.2-22.5,6.6-27.7,10-45.6,4.5-59.4,0-.9-.4-1.7-.6-2.6-.9-18.9-6.1-30.1-17-50.8-9.1-4.1,1.5-8.6,3.8-13.5,7,.8-7.5,2.6-14.7,5.4-21.5,11.1-27.2,37.9-46.4,69.4-46.4,35.5,0,65.1,24.7,72.9,57.9.5,2,.9,4.1,1.1,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116,72.2c-.6.2-1.4.6-2.2,1.3-2.4,2-5,5.6-7.2,10-3.1,6-5.5,13.5-5.2,20.2-.8-4.5-1.3-8.9-1.4-13.2-.1-.9-.1-1.8-.1-2.7s0-1.8.1-2.5c0-.6,0-1.3.1-1.8-.1-1,0-2,.1-2.9.8-7.5,2.6-14.7,5.4-21.5,5.2,3.8,14.7,11.5,10.4,13.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250,87.8c0,.9,0,1.8-.1,2.7-.3,9.5-2.3,19.7-5.6,29.8,1-16.1-.5-34.7-13.4-36.8-1.3-.1-2.7-.1-4.2,0l.4-7.9,15.7-6.6,5.2,1.7c.5,2,.9,4.1,1.1,6.3h0c.4,2.2.6,4.3.6,6.6.1.5.1,1.1.1,1.8.1.8.1,1.7.1,2.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.31d4ee1d11cfbf09dc7e35d25ba298b4.svg";
export { ForwardRef as ReactComponent };